import axios from 'axios';

// Backs the RESOURCES tab: GET {REACT_APP_VERA_BASE_URL}/resource-center
// -> { response: [{ id, label, sequence, items[], subSections[] }] }
export const getResourceCenter = async () => {
  const response = await axios.get(`${process.env.REACT_APP_VERA_BASE_URL}/resource-center`, {
    headers: { Accept: 'application/json, text/plain, */*' },
  });
  const payload = response.data || {};
  return Array.isArray(payload.response) ? payload.response : [];
};

export default { getResourceCenter };
